export default __webpack_public_path__ + "static/context-dont-3-dark-f727547df5d8d2a35d0e360aa8a6a178.png";